import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import CartSearchService from '../services/CartSearchService';
import * as AuthorizationStore from '../store/Authorization';
import { ShoppingCart } from '../models/ShoppingCart';
import CartService from '../services/CartService';
import { Toasts } from '../components/Toasts';
import { toast } from 'react-toastify';

export interface IState {
    items: ShoppingCart[],
    totalCount: number,
    pageIndex: number,
    pageSize: number,
    loading: boolean,
    postBack: boolean,
    appendSearch: boolean,
    mergingCarts: boolean
}

export const unloadedState: IState = {
    items: [],
    totalCount: -1,
    pageIndex: 0,
    pageSize: 8,
    loading: false,
    postBack: false,
    appendSearch: false,
    mergingCarts: false
};

export enum Actions {
    CartSearchBegin = "CartSearchBegin",
    CartSearchEnd = "CartSearchEnd",
    CartSearchError = "CartSearchError",
    CartSearchReset = "CartSearchReset",
    CartMergeBegin = "CartMergeBegin",
    CartMergeEnd = "CartMergeEnd",
}

interface CartSearchBeginAction {
    type: Actions.CartSearchBegin;
    appendSearch: boolean,
}

interface CartSearchEndAction {
    type: Actions.CartSearchEnd;
    items: ShoppingCart[];
    totalCount: number;
    pageIndex: number;
}

interface CartSearchErrorAction {
    type: Actions.CartSearchError;
}

interface CartSearchResetAction {
    type: Actions.CartSearchReset;
}

interface CartMergeBeginAction {
    type: Actions.CartMergeBegin;
}

interface CartMergeEndAction {
    type: Actions.CartMergeEnd;
}

type KnownAction = CartSearchBeginAction | CartSearchEndAction | CartSearchErrorAction | CartSearchResetAction
    | CartMergeBeginAction | CartMergeEndAction;

export const actionCreators = {
    cartSearch: (cartId: string, cartName: string, email: string, pageIndex: number, pageSize: number, appendSearch: boolean): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();

        if (state && state.authorization && state.authorization.currentUser) {
            
            dispatch({
                type: Actions.CartSearchBegin,
                appendSearch,
            });

            const partner = AuthorizationStore.getImpactPartnerFromLocalStorage();
            const response = await CartSearchService.cartSearch(cartId, cartName, email, partner.Id, pageIndex, pageSize);

            if (!response.hasErrors) {
                dispatch({
                    type: Actions.CartSearchEnd,
                    items: response.value.Items,
                    totalCount: response.value.TotalItems,
                    pageIndex
                });
            }
            else {
            }
        }
    },
    cartSearchReset: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        dispatch({
            type: Actions.CartSearchReset,
        });
    },
    cartMerge: (cartIds: string[], cartName: string, callback: () => void): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();

        if (state && state.authorization && state.authorization.currentUser) {

            dispatch({
                type: Actions.CartMergeBegin
            });

            const partner = AuthorizationStore.getImpactPartnerFromLocalStorage();
            const response = await CartService.cartsMerge(cartIds, cartName, state.authorization.currentUser.UserId, partner.Id);

            if (!response.hasErrors) {
                Toasts.createCartSuccess({ cartName: cartName });

                dispatch({
                    type: Actions.CartMergeEnd,
                });
            }
            else {
                toast.error("Cannot create " + cartName);
                console.log("MergeCarts", response.errorMessage);

                dispatch({
                    type: Actions.CartMergeEnd
                });
            }

            if (callback) {
                callback();
            }
        }
    }
};

export const reducer: Reducer<IState> = (state: IState | undefined, incomingAction: Action): IState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case Actions.CartSearchBegin: {

            return {
                ...state,
                loading: true,
                postBack: true,
                appendSearch: action.appendSearch,
                items: !action.appendSearch ? [] : state.items,
                totalCount: !action.appendSearch ? -1 : state.totalCount,
            };
        }

        case Actions.CartSearchEnd: {

            return {
                ...state,
                loading: false,
                totalCount: action.totalCount,
                items: state.appendSearch ? [...state.items, ...action.items] : [...action.items],
                pageIndex: action.pageIndex
            };
        }

        case Actions.CartSearchError: {

            return {
                ...state,
                loading: false
            };
        }

        case Actions.CartSearchReset: {
            return unloadedState;
        }

        case Actions.CartMergeBegin: {
            return {
                ...state,
                mergingCarts: true
            }
        }

        case Actions.CartMergeEnd: {
            return {
                ...state,
                mergingCarts: false,
            }
        }

        default: return state;
    }
};